module.exports = __webpack_public_path__ + "media/excellusbcbs-member@xs-be4d7f1587a959ee17ab340ccf6516c3.jpg";